import axios from "axios";

export const EmailAuth = () => {

    const handleEmailSignin = async (email: string, password: string): Promise<boolean> => {
        const endpoint = '/api/v1.0/desktop/account/email';
        const getAccountEndpoint = '/api/v1.0/desktop/account'

        const requestBody = {
            email: email,
            password: password
        };

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });


            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            var jwt = data.value.jwt;
            localStorage.setItem('subjectToken', data.value.jwt);

            try{
                const response = await axios.get(getAccountEndpoint, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${jwt}`,
                    }
                });

                localStorage.setItem('userEmail', response.data.value.email);
                localStorage.setItem('userName', response.data.value.name);
                localStorage.setItem('role', response.data.value.role);

                localStorage.setItem('isSentimentEnabled', response.data.value.subscription?.isSentimentEnabled);
                localStorage.setItem('isTeamsEnabled', response.data.value.subscription?.isTeamsEnabled);
                localStorage.setItem('isOutlookEnabled', response.data.value.subscription?.isOutlookEnabled);
                localStorage.setItem('isWordEnabled', response.data.value.subscription?.isWordEnabled);

                localStorage.setItem('cancelled', response.data.value.subscription?.cancelled);

                localStorage.setItem('numberOfSeats', response.data.value.numberOfSeats);
                localStorage.setItem('subscriptionType', response.data.value.subscriptionType);
                localStorage.setItem('paid', response.data.value.subscription.paid);

                const hasPassword = !!response.data.value.password;
                localStorage.setItem('hasPassword', hasPassword.toString());

            }
            catch (error){
                console.error('Error Getting account: ', error)
                return false;
            }


            return true;  // Return true on success
        } catch (error) {
            console.error('Error during login:', error);
            return false;  // Return false on failure
        }
    };

    return { handleEmailSignin };

}

